import { render, staticRenderFns } from "./ProjectDetailsForm.vue?vue&type=template&id=6349c63f&"
import script from "./ProjectDetailsForm.vue?vue&type=script&lang=js&"
export * from "./ProjectDetailsForm.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDetailsForm.vue?vue&type=style&index=0&id=6349c63f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports